// components/MaleHealthPage/MaleHealthPage.jsx
import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import CalendarModal from '../CalendarModal/CalendarModal';
import api from '../../services/api';

const MaleHealthPage = ({ onBack, onAddToCart, onAddMultipleToCart, onShowCartNotification }) => {
  const { t } = useTranslation();
  const [selectedServices, setSelectedServices] = useState([]);
  const [showCalendarModal, setShowCalendarModal] = useState(false);
  const [maleHealthServices, setMaleHealthServices] = useState([]);
  const [totalPricePackage, setTotalPricePackage] = useState(0);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const loadServices = async () => {
      setLoading(true);
      setError(null);
      try {
        // Подкатегория ID 13: Мужское здоровье
        const services = await api.getServicesBySubcategory(13);
        
        const mappedServices = services.map((service) => ({
          id: service.id,
          name: service.name,
          price: service.price,
          isTotal: false
        }));
        
        // Рассчитываем общую сумму пакета
        const totalPriceNum = services.reduce((sum, s) => sum + (parseInt(s.price) || 0), 0);
        setTotalPricePackage(totalPriceNum);
        
        // Добавляем итоговую строку с общей суммой
        mappedServices.push({
          id: 'total',
          name: t('maleHealthPage.services.total'),
          price: totalPriceNum,
          isTotal: true
        });
        
        setMaleHealthServices(mappedServices);
      } catch (err) {
        console.error('Ошибка загрузки услуг мужского здоровья:', err);
        setError('Не удалось загрузить услуги');
      } finally {
        setLoading(false);
      }
    };
    
    loadServices();
  }, [t]);

  const toggleService = (serviceId) => {
    const service = maleHealthServices.find(s => s.id === serviceId);
    if (service?.isTotal) return;
    
    if (selectedServices.includes(serviceId)) {
      setSelectedServices(selectedServices.filter(id => id !== serviceId));
    } else {
      setSelectedServices([...selectedServices, serviceId]);
    }
  };

  const handleAddSelectedToCart = () => {
    if (selectedServices.length === 0) {
      showNotification('Выберите хотя бы один анализ');
      return;
    }

    const selectedServicesData = maleHealthServices.filter(service => 
      selectedServices.includes(service.id) && !service.isTotal
    );
    
    selectedServicesData.forEach(service => {
      const cartItem = {
        id: service.id,
        service_id: service.id,
        name: service.name,
        price: `${service.price} ₽`,
        category: 'Мужское здоровье',
      };
      onAddToCart(cartItem);
    });

    if (onShowCartNotification) {
      onShowCartNotification(selectedServicesData.length);
    }

    setSelectedServices([]);
  };

  const handleBookAppointment = () => {
    if (selectedServices.length > 0) {
      setShowCalendarModal(true);
    } else {
      showNotification('Выберите анализы для записи');
    }
  };

  const handleCalendarConfirm = (selectedDate) => {
    const formattedDate = `${selectedDate.date.getDate().toString().padStart(2, '0')}.${(selectedDate.date.getMonth() + 1).toString().padStart(2, '0')}.${selectedDate.date.getFullYear()}`;
    const dayOfWeek = ['воскресенье', 'понедельник', 'вторник', 'среда', 'четверг', 'пятница', 'суббота'][selectedDate.date.getDay()];
    
    const selectedServicesData = maleHealthServices.filter(service => 
      selectedServices.includes(service.id) && !service.isTotal
    );
    
    selectedServicesData.forEach(service => {
      const cartItem = {
        id: service.id,
        service_id: service.id,
        name: service.name,
        price: `${service.price} ₽`,
        category: 'Мужское здоровье',
        date: `${formattedDate} (${dayOfWeek})`
      };
      onAddToCart(cartItem);
    });
    
    if (onShowCartNotification) {
      onShowCartNotification(selectedServicesData.length);
    }
    
    setSelectedServices([]);
    setShowCalendarModal(false);
  };

  const showNotification = (message) => {
    if (window.Telegram?.WebApp) {
      window.Telegram.WebApp.showAlert(message);
    } else {
      alert(message);
    }
  };

  const totalPrice = maleHealthServices
    .filter(service => selectedServices.includes(service.id) && !service.isTotal)
    .reduce((sum, service) => {
      const priceStr = service.price?.toString().replace(/[^\d.]/g, '') || '0';
      return sum + (parseInt(priceStr) || 0);
    }, 0);

  const getServiceNames = () => {
    return selectedServices.map(id => {
      const service = maleHealthServices.find(s => s.id === id);
      return service?.name || '';
    }).filter(Boolean).join(', ');
  };

  if (loading) {
    return (
      <div className="male-health-page">
        <header className="header">
          <div className="clinic-logo">
            <div className="logo-icon">
              <img src="/icons/male-health.png" alt={t('maleHealthPage.title')} width="40" height="40" />
            </div>
            <h1>{t('maleHealthPage.title')}</h1>
          </div>
        </header>
        <main className="main-content">
          <div className="loading-spinner" style={{ textAlign: 'center', padding: '40px', color: 'white' }}>
            Загрузка услуг...
          </div>
        </main>
      </div>
    );
  }

  if (error) {
    return (
      <div className="male-health-page">
        <header className="header">
          <div className="clinic-logo">
            <div className="logo-icon">
              <img src="/icons/male-health.png" alt={t('maleHealthPage.title')} width="40" height="40" />
            </div>
            <h1>{t('maleHealthPage.title')}</h1>
          </div>
        </header>
        <main className="main-content">
          <div className="error-message" style={{ textAlign: 'center', padding: '40px', color: '#e74c3c' }}>
            {error}
            <button 
              className="service-btn" 
              onClick={() => window.location.reload()}
              style={{ marginTop: '20px' }}
            >
              Попробовать снова
            </button>
          </div>
        </main>
        <div className="buttons-grid">
          <button className="service-btn back-btn" onClick={onBack}>
            <span className="btn-icon">←</span>
            <span className="btn-text">{t('maleHealthPage.services.back')}</span>
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="male-health-page">
      <header className="header">
        <div className="clinic-logo">
          <div className="logo-icon">
            <img src="/icons/male-health.png" alt={t('maleHealthPage.title')} width="40" height="40" />
          </div>
          <h1>{t('maleHealthPage.title')}</h1>
        </div>
        
        <div className="user-greeting">
          <p>{t('maleHealthPage.subtitle')}</p>
        </div>
      </header>

      <main className="main-content">
        <div className="welcome-section">
          <h2>{t('maleHealthPage.welcome')}</h2>
          <p className="subtitle">{t('maleHealthPage.description')}</p>
        </div>

        <div className="services-list-section">
          <div className="services-scroll-container">
            {maleHealthServices.map((service) => (
              <div 
                key={service.id}
                className={`service-item ${selectedServices.includes(service.id) ? 'selected' : ''} ${service.isTotal ? 'total-item' : ''}`}
                onClick={() => !service.isTotal && toggleService(service.id)}
                style={service.isTotal ? { cursor: 'default', opacity: '0.9', background: 'rgba(39, 174, 96, 0.15)' } : {}}
              >
                <div className="service-checkbox" style={service.isTotal ? { visibility: 'hidden' } : {}}>
                  {selectedServices.includes(service.id) ? '✓' : ''}
                </div>
                <div className="service-info-full" style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%' }}>
                  <span className="service-name-full" style={{ color: 'white' }}>{service.name}</span>
                  {service.price && (
                    <span className={`service-price ${service.isTotal ? 'total-price' : ''}`} 
                      style={service.isTotal ? { background: 'rgba(39, 174, 96, 0.5)', fontSize: '18px', padding: '8px 16px', color: 'white', borderRadius: '12px' } : { color: 'white' }}>
                      {service.isTotal ? `${service.price} ₽` : `${service.price} ₽`}
                    </span>
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>

        {selectedServices.length > 0 && (
          <div className="selected-services-summary">
            <div className="summary-header">
              <span className="summary-label">Выбрано анализов</span>
              <span className="summary-badge">{selectedServices.length}</span>
            </div>
            
            <div className="summary-total">
              <span className="total-label">Общая сумма</span>
              <span className="total-amount">{totalPrice.toLocaleString()} ₽</span>
            </div>

            <div className="summary-actions">
              <button 
                className="action-btn book-action"
                onClick={handleBookAppointment}
              >
                <span className="action-icon">📅</span>
                <span className="action-text">Записаться</span>
              </button>

              <button 
                className="action-btn cart-action"
                onClick={handleAddSelectedToCart}
              >
                <span className="action-icon">🛒</span>
                <span className="action-text">В корзину</span>
              </button>
            </div>
          </div>
        )}

        <div className="buttons-grid">
          <button 
            className="service-btn back-btn"
            onClick={onBack}
          >
            <span className="btn-icon">←</span>
            <span className="btn-text" style={{ color: 'white' }}>{t('maleHealthPage.services.back')}</span>
          </button>
        </div>
      </main>

      <footer className="footer">
        <p>{t('maleHealthPage.footer.main')}</p>
        <p className="footer-info">{t('maleHealthPage.footer.info')}</p>
      </footer>

      <CalendarModal
        isOpen={showCalendarModal}
        onClose={() => setShowCalendarModal(false)}
        onConfirm={handleCalendarConfirm}
        serviceName={`Мужское здоровье: ${getServiceNames().substring(0, 50)}${getServiceNames().length > 50 ? '...' : ''}`}
        servicePrice={`${totalPrice.toLocaleString()} ₽`}
      />
    </div>
  );
};

export default MaleHealthPage;